import { render, staticRenderFns } from "./PreviewOrder.vue?vue&type=template&id=38069919&scoped=true&"
import script from "./PreviewOrder.vue?vue&type=script&lang=js&"
export * from "./PreviewOrder.vue?vue&type=script&lang=js&"
import style0 from "./PreviewOrder.vue?vue&type=style&index=0&id=38069919&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38069919",
  null
  
)

export default component.exports